export type { SocialLoginButtonProps } from './types';
export { default as SocialLoginButton } from './social-login-button';
